var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('CookieConsent'),_c('div',{staticClass:"container"},[(_vm.$route.meta.h1Title)?_c('h1',{staticClass:"page-title",staticStyle:{"display":"none"}},[_vm._v(_vm._s(_vm.$route.meta.h1Title))]):_vm._e(),_c('router-view'),_c('lg-preview')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }